<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect width="24" height="24"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M19 19V9.625H5V19H19ZM21 20V9.625V8.81758C21 8.69036 20.9757 8.56431 20.9285 8.44619L19.0014 3.62861C18.8496 3.24895 18.4819 3 18.073 3H17.1429H6.85714H5.92703C5.51813 3 5.15042 3.24895 4.99856 3.62861L3.07152 8.44619C3.02428 8.56431 3 8.69036 3 8.81758V9.625V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20ZM6.60407 5L5.15407 8.625H18.8459L17.3959 5H17.1429H6.85714H6.60407ZM15.375 10.875H8.625V12H15.375V10.875Z" :fill="fill_color" :fill-opacity="opacity"/>
	</svg>
</template>

<script>
import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>
